// Module
var code = `<customer-breadcrumbs mode="'GROUP'"></customer-breadcrumbs>
<customer-profile-header mode="'GROUP'" ng-if="\$ctrl.customerId"></customer-profile-header>
<form name="\$ctrl.form">
  <section class="box">
    <div class="profile-body" ng-if="\$ctrl.profile">
      <sub-header header="'Group profile'"></sub-header>
      <div class="tab-menu">
        <ul class="nav-tabs">
          <li class="active"><a data-target="#gpr_tab_data" data-toggle="tab">
            <span><i ng-show="\$ctrl.groupDataForm.\$invalid" class="icon icon-warning-sign"></i>Group data</span>
          </a></li>
          <li ng-if="\$ctrl.propertyConfigService.visible('customer', 'group', 'customers')">
            <a data-target="#gpr_tab_members" data-toggle="tab">
          <span><i ng-show="\$ctrl.isGroupMembersInvalid()"
                   class="icon icon-warning-sign"></i>Group members</span>
            </a></li>
          <li ng-if="\$ctrl.propertyConfigService.visible('customer', 'group', 'addresses')">
            <a data-target="#gpr_tab_addresses" data-toggle="tab">
          <span><i ng-show="\$ctrl.addressesForm.\$invalid || \$ctrl.isGroupAddressesInvalid()"
                   class="icon icon-warning-sign"></i>Collection addresses</span>
            </a></li>
          <li><a data-target="#gpr_tab_schedule" data-toggle="tab">
            <span><i ng-show="\$ctrl.scheduleForm.\$invalid" class="icon icon-warning-sign"></i>Collection schedule</span>
          </a></li>
          <li><a data-target="#gpr_tab_advanced" data-toggle="tab">
          <span><i ng-show="\$ctrl.advancedForm.\$invalid"
                   class="icon icon-warning-sign"></i>Advanced</span>
          </a></li>
        </ul>
      </div>

      <div class="tab-content">
        <div class="tab-pane active" id="gpr_tab_data">
          <group-data
            profile="\$ctrl.profile"
            edit-mode="\$ctrl.editMode"
            form="\$ctrl.groupDataForm"
          >
          </group-data>
        </div>

        <div class="tab-pane"
             id="gpr_tab_members"
             ng-if="\$ctrl.propertyConfigService.visible('customer', 'group', 'customers')">
          <add-group-members profile="\$ctrl.profile" edit-mode="\$ctrl.editMode" form="\$ctrl.groupMembers">
          </add-group-members>
        </div>

        <div class="tab-pane"
             id="gpr_tab_addresses"
             ng-if="\$ctrl.propertyConfigService.visible('customer', 'group', 'addresses')">
          <customer-profile-addresses addresses="\$ctrl.profile.addresses"
                                      edit-mode="true"
                                      ng-form="\$ctrl.addressesForm">
          </customer-profile-addresses>
        </div>

        <div class="tab-pane" id="gpr_tab_schedule">
          <group-schedule profile="\$ctrl.profile" edit-mode="\$ctrl.editMode" form="\$ctrl.scheduleForm">
          </group-schedule>
        </div>

        <div class="tab-pane" id="gpr_tab_advanced">
          <custom-field-input
            group="'CUSTOMER'"
            ng-form="\$ctrl.advancedForm"
            available-custom-fields="\$ctrl.availableCustomFields"
            assigned-category-ids="\$ctrl.profile.categoryIds"
            custom-field-values="\$ctrl.profile.customFieldValues"
            edit-mode="true"
            customer-id="\$ctrl.profile.id">
          </custom-field-input>
        </div>
      </div>

      <div class="tab-content">
        <div>
          <div class="pull-right">
            <button type="button" class="btn btn-warning" ng-click="\$ctrl.cancel()">Cancel</button>
            <button type="button" class="btn btn-primary"
                    ng-if="!\$ctrl.editMode"
                    ng-disabled=
                      "\$ctrl.form.\$invalid
                    || \$ctrl.isGroupAddressesInvalid()
                    || \$ctrl.isGroupMembersInvalid()"
                    command-access="CreateGroupCustomer"
                    ng-click="\$ctrl.save()">
              Save
            </button>
            <button type="button" class="btn btn-primary"
                    ng-if="\$ctrl.editMode"
                    ng-disabled=
                      "\$ctrl.form.\$invalid
                    || \$ctrl.isGroupAddressesInvalid()
                    || \$ctrl.isGroupMembersInvalid()"
                    command-access="UpdateGroupCustomer"
                    ng-click="\$ctrl.update()">
              Update
            </button>
          </div>
        </div>

        <div class="clearfix"></div>
      </div>
    </div>

  </section>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/profile/group-profile.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;